import Vue from 'vue'
// import { queryPermissionsByUser } from '@/api/api'

const user = {
  state: {
    list: [],
    tree: []
  },

  mutations: {
    SET_CATE_DATA: (state, list) => {
      state.tree = list
    },
  },

  actions: {

  }
}

export default user